import { cn } from '@/theme/utils'
import type { ProposalStatus } from '@/types/governance'

type Props = {
  status: ProposalStatus
  className?: string
}

const statusChipClassNameMap: Record<ProposalStatus, string> = {
  PROPOSAL_STATUS_UNSPECIFIED: 'chip-gradient',
  PROPOSAL_STATUS_DEPOSIT_PERIOD: 'chip-gradient',
  PROPOSAL_STATUS_VOTING_PERIOD: 'chip-gradient',
  PROPOSAL_STATUS_PASSED: 'chip-gradient-teal',
  PROPOSAL_STATUS_REJECTED: 'chip-gradient-destructive',
  PROPOSAL_STATUS_FAILED: 'chip-gradient-destructive',
  PROPOSAL_STATUS_CANCELED: 'chip-gradient-destructive',
}

const statusLabelMap: Record<ProposalStatus, string> = {
  PROPOSAL_STATUS_UNSPECIFIED: 'UNSPECIFIED',
  PROPOSAL_STATUS_DEPOSIT_PERIOD: 'DEPOSIT',
  PROPOSAL_STATUS_VOTING_PERIOD: 'VOTING',
  PROPOSAL_STATUS_PASSED: 'PASSED',
  PROPOSAL_STATUS_REJECTED: 'REJECTED',
  PROPOSAL_STATUS_FAILED: 'FAILED',
  PROPOSAL_STATUS_CANCELED: 'CANCELED',
}

export default function GovernanceProposalStatusBadge({
  status,
  className,
}: Props) {
  return (
    <div
      className={cn(
        'inline-flex h-7 items-center rounded-full px-3',
        'text-xs font-semibold',
        'backdrop-blur-md',
        statusChipClassNameMap[status],
        className,
      )}
    >
      {statusLabelMap[status]}
    </div>
  )
}
